import InfoModal from './ui/main/InfoModal';

export default InfoModal;
